import { useContext } from 'react';
import type { PrincipalRef } from '@shared/types';
import { AuthContext, type AuthContextValue } from './auth-provider';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}

export function usePrincipal(): PrincipalRef {
  const { profile } = useAuth();
  if (!profile) throw new Error('No signed-in principal');
  return { type: 'user', id: profile.uid, name: profile.name };
}
